
import React from 'react'
import { Link } from 'react-router-dom'

function Cancellationrefund(props) {
  return (
    <div>
        


        {/* Start Breadcrumb area  */}
      <div className="index-one">
          <main>
           <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                    <h1 className="title split-collab">Cancellation & Refund</h1>
                    <ul className="page-list">
                    <li className="tmp-breadcrumb-item">
                        <a href="/">Home</a>
                    </li>
                    <li className="icon">
                        <i className="fa-solid fa-angle-right" />
                    </li>
                    <li className="tmp-breadcrumb-item active">
                    Cancellation & Refund</li>
                    </ul>
                    <div className="circle-1" />
                </div>
                </div>
            </div>
            </div>
        </div>
            <section className="privacy-policy-section tmp-section-gap">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="inner">
          <div className="section-head text-align-left">
            <h2 className="section-title">Cancellation & Refund Policy</h2>
          </div>

          <p className="description">
            At Vaishnav To Vaishnav Business Organization (v2vbn.org), we strive to provide the best service possible. This Cancellation and Refund Policy outlines the terms under which cancellations and refunds are handled.
          </p>

          <div className="policy-section">
            <h3 className="title">Order Cancellation</h3>
            <p className="description">
              Orders can be cancelled under the following conditions:
            </p>
            <ul className="policy-list">
              <li>Requests for cancellation must be made within 24 hours of placing the order.</li>
              <li>Orders can only be cancelled before they are dispatched or processed for shipping.</li>
              <li>To request a cancellation, please email us at <Link to="mailto:admin@v2vbn.org" style={{ color: "#333" }}>admin@v2vbn.org</Link> with your order ID.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Refund Policy</h3>
            <p className="description">
              Refunds will be issued under the following conditions:
            </p>
            <ul className="policy-list">
              <li>If the order is cancelled before shipment, a full refund will be processed.</li>
              <li>If the product delivered is incorrect or defective, we will initiate a return and process a refund after verification.</li>
              <li>Refunds will be credited to the original payment method within 7–10 business days after approval.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Non-Refundable Items</h3>
            <p className="description">
              The following items/services are non-refundable:
            </p>
            <ul className="policy-list">
              <li>Products that have been used or damaged by the customer.</li>
              <li>Custom-made or personalized items unless defective.</li>
              <li>Digital downloads or services that have already been rendered.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">How to Request a Refund</h3>
            <p className="description">
              To initiate a refund, please contact us at:
            </p>
            <ul className="policy-list">
              <li>📧 Email: <Link to="mailto:admin@v2vbn.org" style={{ color: "#333" }}>admin@v2vbn.org</Link></li>
              <li>Include your Order ID, reason for refund, and supporting documents (if applicable).</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Policy Updates</h3>
            <p className="description">
              We reserve the right to update or modify this Cancellation and Refund Policy at any time. Changes will be posted on this page.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


          </main>
        </div>
        {/* End Breadcrumb area  */}


    </div>
  )
}

export default Cancellationrefund